import { makeStyles, treeItemClasses } from '@rbx/ui';

const useTreeStyles = makeStyles<{ enableNewLayout: boolean }>()((theme, { enableNewLayout }) => ({
  treeRoot: {
    width: '100%',
    '& .MuiTreeItem-iconContainer': {
      paddingLeft: '8px',
    },
    [`& .${treeItemClasses.content}`]: enableNewLayout
      ? {
          flexDirection: 'row-reverse',
        }
      : undefined,
    [`& .${treeItemClasses.group}`]: enableNewLayout
      ? {
          marginLeft: '12px',
        }
      : undefined,
  },

  label: {
    fontSize: enableNewLayout ? '14px' : undefined,
    padding: '0px !important',
    '& .MuiTreeItem-label': {
      padding: '0px',
      // https://jira.rbx.com/browse/CRK-844 - Make the styling part of the
      // actual treeitem when available
      '& *': enableNewLayout
        ? {
            fontSize: '14px',
          }
        : undefined,
    },
    lineHeight: '150%',
  },
  link: {
    fontWeight: 'inherit',
    textAlign: 'left',
    display: 'inline-block',
    width: '100%',
    // add the padding back inside the anchor instead
    padding: enableNewLayout ? '4px 8px' : '4px',
    // https://jira.rbx.com/browse/CRK-844 - Make the styling part of the
    // actual treeitem when available
    lineHeight: '150%',
    fontSize: enableNewLayout ? '14px' : ' 16px',
    '&:hover, &:focus, &:active': {
      backgroundColor: 'transparent',
    },
  },
  openCloudEndpoint: {
    marginLeft: enableNewLayout ? undefined : '-16px',
    width: enableNewLayout ? undefined : 'calc(100% + 16px)',
    [`& .${treeItemClasses.iconContainer}`]: {
      display: enableNewLayout ? 'none' : undefined,
    },
  },
  openInNewIcon: {
    marginLeft: '4px',
    marginBottom: '-2px',
  },
  engineClassInheritanceTreeItem: {
    // NOTE (@tchu, 2025-06-17): this is a reduction of the margin
    // from 24px to 12px to allow for the padding-left of each List
    '& + ul': {
      marginLeft: '12px',
    },
  },
  engineClassInheritanceListContainer: {
    '& > ul:first-of-type > ul': {
      // NOTE (@tchu, 2025-06-18): don't indent first level of inheritance list
      // Object can be the same as the first level of the tree
      paddingLeft: 0,
    },
  },
  engineClassInheritanceList: {
    paddingLeft: '12px',
    marginLeft: 0,
    fontSize: '14px',
    // NOTE (@tchu, 2025-06-18): we need to manage focus and selected state
    // because we're using a ul and li instead of TreeItem directly
    listStyle: 'none',
    '& .Mui-focused': {
      backgroundColor: 'inherit',
      '&:hover': {
        backgroundColor: theme.palette.states.hover,
      },
    },
  },
  selectedClassInheritanceListItem: {
    color: theme.palette.content.standard,
    backgroundColor: theme.palette.states.hover,
  },
}));

export default useTreeStyles;
